export default __webpack_public_path__ + "static/media/logo.2cc404a6.png";